module.exports = __webpack_public_path__ + "static/media/17.b61db66c.jpg";